import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const SETTINGS_PANEL_ID = "__settings__";

export type NavPanelValue = {
  activeId: string | null;
  open: (id: string) => void;
  close: (id?: string) => void;
  toggle: (id: string) => void;
}

export const NavPanelContext = createContext<NavPanelValue | null>(null);

export const useNavPanelState = (): NavPanelValue => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const open = useCallback((id: string) => setActiveId(id), []);
  const close = useCallback((id?: string) => setActiveId((current) => (id === undefined || current === id ? null : current)), []);
  const toggle = useCallback((id: string) => setActiveId((current) => (current === id ? null : id)), []);
  return useMemo(() => ({ activeId, open, close, toggle }), [activeId, open, close, toggle]);
}

export const useNavPanel = (): NavPanelValue => {
  const context = useContext(NavPanelContext);
  const local = useNavPanelState();
  return context ?? local;
}
